// extracted by mini-css-extract-plugin
module.exports = {"card_container":"cardStyles_card_container__38xM1"};